import Accordion from 'accordion-js';
import domReady from '@wordpress/dom-ready';

domReady(() => {
  const currentAccordionID = window.location.hash;
  const containers = document.querySelectorAll('.accordion-container');
  const isTemplateMode = document.body.classList.contains(
    'page-template-template-member-add-user'
  );

  if (0 < containers.length) {
    containers.forEach((container) => {
      let currentAccordion = null;
      const openedAccordions = [];

      if (currentAccordionID) {
        currentAccordion = container.querySelector('.ac' + currentAccordionID);
      }

      if (currentAccordion) {
        const currentGroup = currentAccordion.parentNode;
        const currentIndex = Array.prototype.indexOf.call(
          currentGroup.children,
          currentAccordion
        );
        openedAccordions.push(currentIndex);
      }

      const showIndex =
        container.closest('.block-accordions-group').dataset.showIndex === '1';
      if (showIndex) {
        let index = 1;
        const accordions = container.querySelectorAll('.accordion__accordion');
        accordions.forEach((accordion) => {
          const indexSpan = accordion.querySelector(
            '.accordion__header__index'
          );
          if (indexSpan) {
            indexSpan.textContent = `${index < 10 ? '0' : ''}${index}.`;
            index++;
          }
        });
      }

      new Accordion(container, {
        duration: 400,
        showMultiple: !isTemplateMode, // false sur page-template-template-member-add-user
        openOnInit: openedAccordions,
      });
    });
  }
});
